"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Authentication = void 0;
const lodash_1 = require("lodash");
const MissingAuthParameter_1 = require("../errors/MissingAuthParameter");
class Authentication {
    constructor(authParams) {
        this.authParams = authParams;
    }
    updateAuthParams(authParams) {
        this.authParams = Object.assign(Object.assign({}, this.authParams), authParams);
    }
    clearAuthParams() {
        this.authParams = {};
    }
    getQueryEngineAccessToken() {
        if (!this.authParams.queryEngineAccessToken)
            throw new MissingAuthParameter_1.MissingAuthParameter('queryEngineAccessToken');
        return this.authParams.queryEngineAccessToken;
    }
    getProjectAdminOverrideToken() {
        return this.authParams.projectAdminOverrideToken;
    }
    getDashboardAccessToken() {
        if (!this.authParams.dashboardAccessToken)
            throw new MissingAuthParameter_1.MissingAuthParameter('dashboardAccessToken');
        return this.authParams.dashboardAccessToken;
    }
    getAppSessionToken() {
        return this.authParams.appSessionToken;
    }
    getDataAccessToken() {
        if (!this.authParams.dataAccessToken)
            throw new MissingAuthParameter_1.MissingAuthParameter('dataAccessToken');
        return this.authParams.dataAccessToken;
    }
    getProjectApiKey() {
        if (!this.authParams.projectApiKey)
            throw new MissingAuthParameter_1.MissingAuthParameter('projectApiKey');
        return this.authParams.projectApiKey;
    }
    getProjectAccessToken() {
        if (!this.authParams.projectAccessToken)
            throw new MissingAuthParameter_1.MissingAuthParameter('projectAccessToken');
        return this.authParams.projectAccessToken;
    }
    buildAuthHeaders(acceptedAuthParams) {
        let usableAuthParams = acceptedAuthParams ? (0, lodash_1.pick)(this.authParams, acceptedAuthParams) : this.authParams;
        if (usableAuthParams.dashboardAccessToken) {
            return {
                auth: `Bearer ${usableAuthParams.dashboardAccessToken}`,
            };
        }
        // If a project access token has been set on the config, use that instead
        // of fetching one. This is most likely used on the managed query-engine where we
        // pass the project access token through in a request header.
        if (usableAuthParams.projectAccessToken) {
            return {
                auth: `Bearer ${usableAuthParams.projectAccessToken}`,
            };
        }
        if (usableAuthParams.projectApiKey) {
            return {
                auth: `Api-Key ${usableAuthParams.projectApiKey}`,
            };
        }
        if (usableAuthParams.appSessionToken) {
            return {
                auth: `Bearer ${usableAuthParams.appSessionToken}`,
            };
        }
        return {};
    }
}
exports.Authentication = Authentication;
